import"./index-8p04sssx.mjs";
import {
  createRectTransformImplementations
} from "./index-s9mrx750.mjs";
import {
  assertOptionalFiniteNumber
} from "./index-wxhvgv2s.mjs";
import {
  assertEffectParamsObject
} from "./index-4fvp93ps.mjs";

// src/translate/index.ts
import { Internals } from "remotion";
var { createEffect } = Internals;
var xyTranslateSchema = {
  x: {
    type: "number",
    step: 1,
    default: 0,
    description: "X",
    hiddenFromList: false
  },
  y: {
    type: "number",
    step: 1,
    default: 0,
    description: "Y",
    hiddenFromList: false
  }
};
var uvTranslateSchema = {
  u: {
    type: "number",
    step: 0.01,
    default: 0,
    description: "U",
    hiddenFromList: false
  },
  v: {
    type: "number",
    step: 0.01,
    default: 0,
    description: "V",
    hiddenFromList: false
  }
};
var resolveXyTranslate = (params) => ({
  x: params.x ?? 0,
  y: params.y ?? 0
});
var resolveUvTranslate = (params) => ({
  u: params.u ?? 0,
  v: params.v ?? 0
});
var validateXyTranslateParams = (params) => {
  assertEffectParamsObject(params, "xyTranslate");
  assertOptionalFiniteNumber(params.x, "x");
  assertOptionalFiniteNumber(params.y, "y");
};
var validateUvTranslateParams = (params) => {
  assertEffectParamsObject(params, "uvTranslate");
  assertOptionalFiniteNumber(params.u, "u");
  assertOptionalFiniteNumber(params.v, "v");
};
var applyTranslate = ({
  source,
  target,
  width,
  height,
  x,
  y
}) => {
  const ctx = target.getContext("2d");
  if (!ctx) {
    throw new Error("Failed to acquire 2D context for translate effect. The canvas may have been assigned a different context type.");
  }
  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(source, x, y, width, height);
};
var xyTranslate = createEffect({
  type: "dev.remotion.effects.xyTranslate",
  label: "xyTranslate()",
  documentationLink: "https://www.remotion.dev/docs/effects/xy-translate",
  calculateKey: (params) => {
    const r = resolveXyTranslate(params);
    return `xy-translate-${r.x}-${r.y}`;
  },
  implementations: {
    ...createRectTransformImplementations("xyTranslate", (params, width, height) => {
      const r = resolveXyTranslate(params);
      return { x: r.x, y: r.y, width, height };
    }),
    "2d": Internals.createEffectImplementation({
      setup: () => null,
      apply: ({ source, target, width, height, params }) => {
        const r = resolveXyTranslate(params);
        applyTranslate({
          source,
          target,
          width,
          height,
          x: r.x,
          y: r.y
        });
      },
      cleanup: () => {
        return;
      }
    })
  },
  schema: xyTranslateSchema,
  validateParams: validateXyTranslateParams
});
var uvTranslate = createEffect({
  type: "dev.remotion.effects.uvTranslate",
  label: "uvTranslate()",
  documentationLink: "https://www.remotion.dev/docs/effects/uv-translate",
  calculateKey: (params) => {
    const r = resolveUvTranslate(params);
    return `uv-translate-${r.u}-${r.v}`;
  },
  implementations: {
    ...createRectTransformImplementations("uvTranslate", (params, width, height) => {
      const r = resolveUvTranslate(params);
      return { x: r.u * width, y: r.v * height, width, height };
    }),
    "2d": Internals.createEffectImplementation({
      setup: () => null,
      apply: ({ source, target, width, height, params }) => {
        const r = resolveUvTranslate(params);
        applyTranslate({
          source,
          target,
          width,
          height,
          x: r.u * width,
          y: r.v * height
        });
      },
      cleanup: () => {
        return;
      }
    })
  },
  schema: uvTranslateSchema,
  validateParams: validateUvTranslateParams
});
export {
  uvTranslate,
  xyTranslate
};
